import { all, call, put, retry, spawn, take } from 'redux-saga/effects';

import { handleSagaError } from '»utils/handleSagasError';

import { menusSlice } from './_menus.slice';
import { menuTypes } from './menus.helper';
import { menuServices } from './menus.services';

const menuWorker = function* () {
  try {
    const mainMenu = yield retry(3, 2000, menuServices.menu);

    yield put(
      menusSlice.actions.menuSucess({
        menuId: menuTypes.MAIN,
        mainMenu,
      }),
    );
  } catch (error) {
    const handled = yield call(handleSagaError, error);
    if (!handled)
      yield put(
        menusSlice.actions.menuFailure({ menuId: menuTypes.MAIN, error }),
      );
  }
};

const menusListener = function* () {
  while (true) {
    try {
      yield take(menusSlice.actions.menuRequest.type);
      yield all([call(menuWorker)]);
    } catch {}
  }
};

export const menusSagas = function* () {
  try {
    yield all([spawn(menusListener)]);
  } catch {}
};
